export default __webpack_public_path__ + "static/media/apoorva-h.abf15a10.jpg";